import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import { css, cx } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import CommunityCard from '../../components/CommunityCard';
// import { colors } from '../../styles';

const styles = css`
  height: 100%;
  .CommunitiesList_list {
    margin: 0;
  }
  .CommunitiesList_listItem {
  }
`;


function CommunitiesList({ className, communities, sort, small }) {
  return (
    <div className={cx(styles, className)}>
      <ul className="CommunitiesList_list list-unstyled row justify-content-center">
        {
          orderBy(communities, sort.field, get(sort, 'dir', 'asc')).map(community => (
            <li className={`CommunitiesList_listItem ${!small && 'col-12'} ${small && 'col-12 col-lg-4'}`} key={community._id}>
              <CommunityCard className="CommunitiesList_card" community={community} small={small} />
            </li>
          ))
        }
      </ul>
    </div>
  );
}

CommunitiesList.propTypes = {
  className: PropTypes.string,
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
  sort: PropTypes.object.isRequired,
  small: PropTypes.bool,
};

CommunitiesList.defaultProps = {
  className: '',
  small: false,
};

export default withData({
  communities: true,
})(CommunitiesList);



// WEBPACK FOOTER //
// ./src/pages/Communities/List.js